export const STATUS_OPENED = 'OPENED'
export const STATUS_REGISTRATION_OPENED = 'REGISTRATION_OPENED'
export const STATUS_REGISTRATION_CLOSED = 'REGISTRATION_CLOSED'
export const STATUS_CHECKIN = 'CHECKIN'
export const STATUS_STARTED = 'STARTED'
export const STATUS_IN_PROGRESS = 'IN_PROGRESS'
export const STATUS_PENDING = 'PENDING'
export const STATUS_FINISHED = 'FINISHED'
export const STATUS_CLOSED = 'CLOSED'
